<template>
  <div class="section">
    <h3 class="divider">{{details.title}}</h3>
    <div v-for="(item, index) in details.items" :key="index">
      <div class="personal-item-title">{{item.title}}</div>
      <ul v-if="item.lines && item.lines.length" class="personal-item-details">
        <li v-for="(line, index) in item.lines" :key="index" v-html="line"></li>
      </ul>
    </div>  
  </div>
</template>

<script>
export default {
  name: 'PersonalDetails',
  props: {
    details: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
}
</script>

<style lang="scss" scoped>
  .personal-item-title {
    font-weight: 600;
    font-size: 14px;
    padding-bottom: 0.2rem;
    padding-top: 0.3rem;
  }
  .personal-item-details {
    list-style: none;
    padding-left: 0;
    font-size: 14px;
    margin: 0.3rem 0 0.5rem;
    color: #333;
    & li + li {
      padding-top: .2rem;
    }
  }
</style>
